import React from 'react';
import { Link } from 'react-router-dom';
import ThemeToggle from './ThemeToggle'; 
import { 
  FaFacebookF, 
  FaTelegram, 
  FaLinkedinIn, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaTiktok
} from 'react-icons/fa';
import './footer.css'; 

const Footer = () => {
  return (
    <footer className="footer-section text-white">
      <div className="container py-5">
        <div className="row text-center text-md-start">
          {/* Logo and Description */}
          <div className="col-md-4 mb-4 text-center">
            <h2 className="footer-logo mb-3">Iklim Digitals</h2>
            <p className="footer-text">
              Connecting Brands with Success. Elevate your digital presence with us.
            </p>
          
          
          </div>
         

          {/* Useful Links */}
          <div className="col-md-4 mb-4">
            <h5 className="mb-3">Useful Links</h5>
            <ul className="list-unstyled useful-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/aboutus">Portfolio</Link></li>
              <li><Link to="/contactus">Contact Us</Link></li>
              <ThemeToggle />
            </ul>
          </div>
          
          {/* Contact Information */}
          <div className="col-md-4 mb-4">
            <h5 className="mb-3">Contact Us</h5>
            <ul className="list-unstyled contact-info text-white">
            <li className="mb-2"><FaPhoneAlt className="me-2" /> +251904803380</li>
              <li className="mb-2"><FaPhoneAlt className="me-2" /> +251902340084</li>
              <li className="mb-2">
                <FaEnvelope className="me-2" /> 
                <a href="mailto:info@iklimdigitals.com" className="text-white">info@iklimdigitals.com</a>
              </li>
            </ul>

            {/* Main Office */}
            <h6 className="mt-4">Main Office</h6>
            <p className="main-office text-white">
              <FaMapMarkerAlt className="me-2 text-white" /> 
              Minch Market Center, Adama, Ethiopia
            </p>
          </div>
        </div>

        {/* Social Media Icons */}
        <div className="text-center mt-4">
          <a href="https://www.facebook.com/IklimDigitals" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="social-link mx-2">
            <FaFacebookF />
          </a>
          <a href="https://www.tiktok.com/@iklimdigitals" target="_blank" rel="noopener noreferrer" aria-label="Tiktok" className="social-link mx-2">
            <FaTiktok />
          </a>
          <a href="https://www.t.me/iklimdigitals" target="_blank" rel="noopener noreferrer" aria-label="Telegram" className="social-link mx-2">
            <FaTelegram /></a>
          
          <a href="https://www.linkedin.com/in/iklim-digitals-a15262323/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="social-link mx-2">
            <FaLinkedinIn />
          </a>
        </div>

        {/* Copyright */}
        <div className="footer-bottom text-center mt-4 pt-3 border-top border-secondary">
          <p className="mb-0 text-white">© {new Date().getFullYear()} Iklim Digitals. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
